export default {
  apply: {
    congrat_1_steps: 'Scan the QR code from your smartphone camera',
    congrat_2_steps: 'Download the app and finalize your profile',
    congrat_3_steps: 'Access your condidature and hundreds of missions near you',
    download_app: 'Download',
    form_address_label: 'Address',
    form_address_placeholder: '646 Michigan Ave, Chicago, IL 60611, USA',
    form_email_label: 'E-mail',
    form_email_placeholder: 'johndoe@gmail.com',
    form_firstname_label: 'First name',
    form_firstname_placeholder: 'John',
    form_lastname_label: 'Last name',
    form_lastname_placeholder: 'Doe',
    form_phone_label: 'Phone',
    form_phone_placeholder: '1 (312) 555-3890',
    form_resume_button: 'Import',
    form_resume_label: 'CV',
    message_info_accept_tcu: 'By continuing, you agree to the',
    tcu_confidentiality: 'Terms of Service',
    message_info_accept_conditions: 'well as the',
    tcu_conditions: 'Privacy Policy',
    modal_action_apply: 'Apply',
    modal_action_close: 'To close',
    step_unknown: {
      dropzone: {
        drop: 'Drop or ',
        select: 'select your file',
        supported_files: 'Supported files : IMAGES, PDF, DOC, DOCX',
      },
    },
    subtitle_download_app: 'Download our app to track your application.',
    subtitle_email_to_identify: 'Your email allows us to identify if we already know each other.',
    subtitle_resume_to_apply: 'We need your CV and contact details to process your application.',
    title_free_apply: 'Apply for a mission',
    title_job_offer_apply: 'Apply for this mission',
    title_congratulation: 'Well done, your application has been sent!',
    title_you_are_new: "We don't know each other yet!",
  },
  free_application_card: {
    button: 'Go',
    message: 'Send in your resume and we’ll get in touch as soon we find something for you.',
    title: 'Find your dream job yet?',
  },
  banner: {
    join_community: 'Join the community',
    large_choice: 'Wide selection of jobs',
    large_choice_desc:
      'I have access to a wide range of temporary, fixed-term and permanent positions in my area, across all fields that interest me.',
    personal_service: 'Personalized & rewarding support',
    personal_service_desc:
      'My dedicated recruitment manager supports me day-to-day. The more I work with, the more benefits I receive!',
    simple_and_fast: 'Simple & quick',
    simple_and_fast_desc:
      'No more trips to the agency: I choose my assignment in 3 clicks, I simply upload my documents.',
  },
  browse_page: {
    heading: 'Find jobs near to',
    title: 'Our jobs near to',
  },
  consent_manager: {
    content:
      'We use the information collected by cookies and JavaScript libraries to improve your browsing experience, analyze traffic on our site, display personalized advertisements and increase the performance of our site.',
    title: 'Manage my preferences',
  },
  currencies: {
    EUR: '€',
    USD: '$',
  },
  date: {
    today: 'today',
  },
  error_pages: {
    internal_server_error_title: 'Oops, there was an error...',
    not_found_subtitle1: "Don't worry, our developpers are looking for it!",
    not_found_subtitle2: 'Until then, you can go back to the previous page.',
    not_found_title: "Oops, it seems like the page you're looking for disappeared...",
    redirect_label: 'Back home',
  },
  field_errors: {
    address_valueIncomplete: 'Address is incomplete',
    address_valueMissing: 'Address is required',
    captcha_valueMissing: 'The field is required',
    email_typeMismatch: 'Email is incorrect',
    email_valueMissing: 'Email is required',
    firstname_valueMissing: 'First name is required',
    lastname_valueMissing: 'Name is required',
    phone_typeMismatch: 'Phone is incorrect',
    phone_valueMissing: 'Phone is required',
    resume_invalidSize: 'The file size must be between 1KB and 10MB',
    resume_invalidType: 'The file type is not valid',
    resume_valueMissing: 'CV is required',
  },
  footer: {
    aboutUs: 'About Us',
    account: 'My Account',
    askADemo: 'Ask for a demo',
    blog: 'Blog',
    browse: 'Browse jobs',
    companies: 'Companies',
    companySpace: 'Business space',
    confidentiality: 'Confidentiality',
    cookies_policy: 'Cookies Policy',
    cookies_settings: 'Cookies settings',
    join: 'Join us',
    legalMentions: 'Legal Mentions',
    partners: 'Partners',
    personalData: 'Personal Data',
    press: 'Press',
    program: 'Partners Program',
    socialMedia: {
      facebook: 'Follow us on Facebook',
      instagram: 'Check our stories on Instagram',
      linkedin: 'Add us on LinkedIn',
      twitter: 'Check our Stories on Twitter',
    },
    usageConditions: 'Terms of Use',
    who: 'Who are we?',
    why: 'Why ?',
    worker: 'Worker',
  },
  form_errors: {
    address: 'Please select a city',
    job: 'Please enter a job',
  },
  form_labels: {
    address: 'City',
    distance: '< {{distance}} miles',
    experience: 'Experience required',
    job: 'Job',
    sort: 'Sort by',
    type: 'Contract type',
  },
  form_option_labels: {
    experience: {
      all: 'All',
      any: 'First experience required',
      five_years: 'More than 5 years',
      none: 'No experience required',
      one_month: 'At least 1 month',
      one_year: 'At least 1 year',
      six_months: 'At least 6 months',
      three_months: 'At least 3 months',
      two_years: 'Between 2 years and 5 years',
    },
    sort: {
      publication: 'Publication date',
      relevance: 'Relevance',
    },
    type: {
      all: 'All',
      contract: 'Fixed contract',
      non_seasonal_temporary: 'Interim',
      permanent: 'Permanent contract',
      seasonal_temporary: 'Interim',
      temporary: 'Interim',
    },
    urgent: 'Urgent',
  },
  form_option_values: {
    experience: {
      any: 'first',
      five_years: '5 years and over',
      none: 'none',
      one_month: '1 month',
      one_year: '1 year',
      six_months: '6 months',
      three_months: '3 months',
      two_years: '2 years and above',
    },
    sort: {
      publication: 'publication',
      relevance: 'relevance',
    },
    type: {
      contract: 'fixed',
      non_seasonal_temporary: 'non-seasonal interim',
      permanent: 'permanent',
      seasonal_temporary: 'seasonal interim',
      temporary: 'interim',
    },
  },
  form_placeholders: {
    address: 'Search for a city',
    job: 'Search for a job',
  },
  form_title: 'Your search for',
  header: {
    findMission: 'Find a job',
    myApply: 'My Applications',
    partners: 'Partners',
  },
  languages: {
    dev: 'dev',
    en: 'English',
    fr: 'Français',
    it: 'Italiano',
  },
  'meta-description': {
    jobOffer: {
      suffix: 'Apply now, work tomorrow!',
      type: {
        contract: 'Consult our fixed-term mission of {{title}} in {{city}}.',
        permanent: 'Consult our permanent mission of {{title}} in {{city}}.',
        temporary: 'Consult our interim mission of {{title}} in {{city}}.',
      },
    },
  },
  'meta-social-description': {
    mission_description: 'Find your mission as {{displayName}} near {{city}}. Apply now, work tomorrow!',
    mission_title: '{{displayName}} - {{city}} ({{areaCode}}) - Job offers',
    partner_description: 'Dozens of offers near {{city}} ! Apply quickly and easily.',
    partner_title: 'Our job offers near {{city}} ({{areaCode}})',
  },
  missions: {
    about: 'About the mission',
    apply: 'Apply',
    back: 'Back to search',
    bonuses: 'Bonuses',
    certificates: 'Certificates',
    close_distance: 'close',
    contractType: 'Contrat type',
    details_tab_label: 'Details',
    distance: '{{distance}} miles away',
    experience: 'Experience',
    informations: 'Informations',
    location: 'Location',
    no_certificates_required: 'No certificate required',
    no_experience_required: 'No experience required (summer job, etc.)',
    outdated: {
      oops_text: 'this job offer no longer exists.',
      subtitle: 'Download the app to access all missions',
    },
    profile: 'Profil recherché',
    published: 'Published ',
    remuneration: 'Remuneration',
    see_all_missions: 'See all his/her jobs',
    weekly_hours: {
      default: '{{hours}} hours / weekly',
      hours: '{{hours}} hours',
      per_week: 'per week',
    },
    workTime: 'Work time',
  },
  no_mission_modal: {
    button: {
      close: 'Close',
      next: 'Next',
    },
    download_app: 'Download the app now!',
    download_app_subtitle: 'Register and complete your profile in 5 minutes thanks to our CV analysis system.',
    placeholder: {
      email: 'Your email address',
      phone: 'Your phone number',
    },
    step: 'Step {{step}} / 2',
    subtitle:
      'We are constantly looking for the best opportunities for you! Fill in your information, and we will inform you as soon as we have missions to offer you:',
    success: {
      body: 'Register and complete your profile in 5 minutes using our CV analysis system.',
      subtitle: "You're almost there !",
      title: 'Find out new missions in our app',
    },
    title: 'It seems that no offers has been found!',
  },
  no_missions_result: {
    download_app: 'Download the app now!',
    subtitle:
      'We are constantly looking for the best opportunities for you! Download the application and we will inform you as soon as we have missions to offer you.',
    title: 'Oops, looks like no deals were found!',
  },
  salary: {
    gross_per_unit: {
      hourly: 'Gross/hour',
      monthly: 'Gross/month',
      yearly: 'Gross/year',
    },
  },
  search_params: {
    address: 'city',
    distance: 'distance',
    experience: 'experience',
    job: 'job',
    page: 'page',
    sort: 'sort',
    type: 'contract',
  },
  tags: {
    experience: {
      any: 'First experience required',
      five_years: 'More than 5 years of experience',
      none: 'No experience required',
      one_month: 'At least 1 month of experience',
      one_year: 'At least 1 year of experience',
      six_months: 'At least 6 months of experience',
      three_months: 'At least 3 months of experience',
      two_years: 'Between 2 years and 5 years of experience',
    },
  },
  title: {
    '404_error': 'Page not found - job offers',
    '500_error': 'Unknown error - jobs',
    mission_page: 'job',
    partner_page: 'Job offers',
  },
  toasts: {
    application_error_body: 'Your application has not been taken into account, please try again later.',
    application_error_title: 'An error has occurred',
  },
  url: {
    askADemo: 'recrutement-interim',
    blog: 'blog',
    companySpace: 'entreprises',
    confidentiality: 'charte-de-confidentialite',
    cookie: 'politique-de-cookies',
    legalMentions: 'mentions-legales',
    partners: 'partners',
    personalData: 'formulaire-exercice-droits',
    press: 'presse',
    usageConditions: 'conditions-generales-dutilisation',
    who: 'a-propos',
    why: 'why',
  },
  welcome: 'Welcome',
  welcome_page: {
    meta_description: 'Find our offers near you and apply with just a few clicks',
    meta_social_description: 'Positions to be filled near you! Easy and fast application.',
    meta_social_description_city: 'Openings near {{city}} ! Easy and fast application.',
    meta_social_title: 'Find our offers near from you',
    meta_social_title_city: 'Our job offers near {{city}}',
    'meta_social_title_city&zipcode': 'Our vacancies near {{city}} ( {{zipcode}} )',
    meta_title: 'Our job offers',
    meta_title_city: '{{city}} - Our job offers',
    'meta_title_city&zipcode': '{{city}} ( {{zipcode}} ) - Our job offers',
    missions_available_0: 'No offers available',
    missions_available_1: '1 offer found',
    missions_available_other: '{{count}} offers found',
    title_at_your_place: 'at your place!',
    title_our_offers_near: 'Our offers\nnear',
  },
};
